import type React from 'react';

export const createEnterKeyHandler =
  (isDisabled: boolean, onSubmit: () => void) =>
  (event: React.KeyboardEvent<HTMLInputElement> | KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (!isDisabled) {
        onSubmit();
      }
    }
  };
